import type { Logger } from "@offstreetparking/logger";
import * as z from "zod/v4";

const ENVIRONMENTS = ["production", "test", "development", "automatedtest"] as const;
export const tracingEnvironmentSchema = z.preprocess((val: unknown) => {
	if (typeof val === "string" && ENVIRONMENTS.some((env) => env === val)) {
		return val;
	}
	return undefined;
}, z.enum(ENVIRONMENTS).optional());

export type TracingEnvironment = z.infer<typeof tracingEnvironmentSchema>;

const tracingOptionsSchema = z.object({
	service: z.string().optional(),
	environment: z.string().optional(),
	version: z.string().optional(),
});

export const clientTracingOptionsSchema = tracingOptionsSchema.extend({
	service: z.string(),
	datadogApplicationId: z.string(),
	datadogClientToken: z.string(),
	apiUrl: z.string(),
	sampleRate: z.number().min(0).max(1).optional(),
	// Required on parker-facing apps; turning it off needs compliance sign-off (docs/telemetry-privacy.md).
	redactPersonalData: z.boolean().optional(),
});

export type ClientTracingOptions = z.infer<typeof clientTracingOptionsSchema>;

export const serverTracingOptionsSchema = tracingOptionsSchema.extend({
	datadogApiKey: z.string().optional(),
	trpcPaths: z.array(z.string().min(1)).optional(),
});

export type ServerTracingOptions = z.infer<typeof serverTracingOptionsSchema> & { logger: Logger };

export type CaptureContext = {
	extra?: Record<string, unknown>;
};

export type CaptureExceptionOptions = {
	error: Error;
	context?: CaptureContext;
	logger: Logger;
};

export type CaptureMessageOptions = {
	message: string;
	context?: CaptureContext;
	logger: Logger;
};
